import { Component, OnInit } from '@angular/core';
import { DashboardBalanceHandler } from './dashboard-balance.handler';
import { AgentService } from 'src/app/agent/services/agent.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-dashboard-balance',
  templateUrl: './dashboard-balance.component.html',
  styleUrls: ['./dashboard-balance.component.scss'],
})
export class DashboardBalanceComponent extends DashboardBalanceHandler {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  // ngOnInit() {
  //   super.ngOnInit();
  // }
}
